import axiosInstance from "../../../core/api/axios";
import { normalizeEnem, normalizeGenres, normalizeFuvest, normalizeUfpr, normalizeUnesp, normalizeUnicamp, normalizeOldFuvest } from "../utils/normalizer";

export async function getFeedback(slug: string, tryNumber: number) {
  try {
    const { data } = await axiosInstance.get(`/essays/myessays/${slug}/feedback/${tryNumber}`)
    let dataFinal = data;
    
    if(data.banca === 'ENEM') {
      dataFinal = normalizeEnem(data);
    }

    if(data.banca === 'GENERO') {
      dataFinal = normalizeGenres(data);
    }

    if(data.banca === 'FUVEST' && !data.isOld) {
      dataFinal = normalizeFuvest(data);
    }

    if(data.banca === 'FUVEST' && data.isOld) {
      dataFinal = normalizeOldFuvest(data);
    }

    if(data.banca === 'UFPR') {
      dataFinal = normalizeUfpr(data)
    }    

    if(data.banca === 'UNESP') {
      dataFinal = normalizeUnesp(data)
    }

    if(data.banca === 'UNICAMP') {
      dataFinal = normalizeUnicamp(data)
    }    

    return dataFinal;
  } catch(e: any) {
    throw new Error(e);
  }
}

export interface IReviewBody {
  essayFeedbackId: string; //ID da redação
  rating: string;
  ratingComment: string;
  ratingReason: string;
}

export const sendReview = async (body: IReviewBody) => {
  try {
    const response = await axiosInstance.post(`/essays/review`, body);

    return response.data
  } catch(e: any) {
    throw new Error(e);
  }
}